import React, { useState, useEffect } from 'react'
import { Container } from './styles'
import { LoginImage, LoginLine, PosLogoSquared } from '../../../assets/images'
import { TextInput, Button } from '../../../shared_components'
import loginApi from '../../../services/login'
import { handleGetTokens, handleAuthedStore } from '../../../config/store/actions/auth'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Helmet from 'react-helmet'
import t from '../../../config/translate'

function RecoverPassword({ dispatch, history, location, logo, whitelabel_name, match }) {

    const [loginError, setLoginError] = useState({
        active: false,
        message: t('recover_password.error'),
    })

    const [isLoading, setIsLoading] = useState(false)

    const submitLogin = (e) => {
        e.persist();
        e.preventDefault();
        const form = e.target
        let login_password_1 = form['login_password_1'].value
        let login_password_2 = form['login_password_2'].value
        if ((login_password_1 === login_password_2) && (login_password_1.length >= 8)) {
            let requestedUser = match.params.token
        
            loginApi.updatePass(login_password_1, requestedUser, window.location.hostname)
                .then(res => {
                    if (res.status === 200) {
                        setLoginError({
                            active: true,
                            message: t('recover_password.success')
                        })

                        setTimeout(() => {
                            history.push('/login')
                        }, 3000)

                    }
                })
                .catch((e) => { 
                    if (e.response.status === 404) {
                        setLoginError({
                            active: true,
                            message: t('recover_password.not_found')
                        })
                    } else if (e.response.status === 400) {
                        setLoginError({
                            active: true,
                            message: t('recover_password.error')
                        })
                    } 
                    setIsLoading(false) 
                })
        } else {
            setLoginError({
                active: true,
                message: t('recover_password.error')
            });
            setIsLoading(false)
        }

    }

    const redirectBack = () => {
        if (location.state && location.state.referrer) {
            history.push(location.state.referrer)
        } else {
            history.push('/')
        }

    }


    return (
        <Container>
            <Helmet>
                <title>{t('recover_password.title')} | {whitelabel_name}</title>
            </Helmet>
            <img className='login_line' src={LoginLine} alt='login_line' />

            <div className='content_container'>

                <div className='form_container'>
                    {logo ? <img src={logo} alt='Company Logo' className='logo' /> : <img src={PosLogoSquared} className='logo' />}

                    <div>
                        <h1>{t('recover_password.title')}</h1>
                        <form onSubmit={submitLogin} className='input_container'>
                            <TextInput maxLength={'15'} type={'password'} id='login_password_1' placeholder={t('recover_password.new_password')} />
                            <TextInput maxLength={'15'} type={'password'} id='login_password_2' placeholder={t('recover_password.repeat_password')} />
                            <Button type={'submit'} text={t('save')} />
                            {loginError.active && <p className='error_message'>{loginError.message}</p>}
                        </form>

                    </div>

                </div>
                <div className='image_container'>
                    <img src={LoginImage} alt='POS Machine' />
                </div>
            </div>


        </Container>
    )
}

function mapStateToProps({ auth, theme }) {
    return {
        tokens: auth.tokens || {},
        logo: theme.logo,
        whitelabel_name: theme.whitelabel_name || 'POS CONTROLE',
    }
}


export default withRouter(connect(mapStateToProps)(RecoverPassword))